import { render, staticRenderFns } from "./CurrencyRateDisplay.vue?vue&type=template&id=31b56cb2"
import script from "./CurrencyRateDisplay.vue?vue&type=script&lang=js"
export * from "./CurrencyRateDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports